import type { MarketplaceDefinition } from '../hooks/useMarketplaceDefinitions';
import { assembleMarketplaceOptionLabel } from './taskGroupAssemble';

const MAX_PLATFORM_IDS = 50;

export function sanitizeReviewMarketplaceIds(ids?: string[] | null): string[] {
  if (!ids?.length) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of ids) {
    const value = (raw || '').trim();
    if (!value || seen.has(value)) continue;
    seen.add(value);
    out.push(value);
    if (out.length >= MAX_PLATFORM_IDS) break;
  }
  return out;
}

export function reviewPlatformOptions(
  definitions: MarketplaceDefinition[]
): MarketplaceDefinition[] {
  return definitions
    .filter(def => Boolean(def.id) && !def.is_template)
    .slice()
    .sort((a, b) =>
      assembleMarketplaceOptionLabel(a).localeCompare(assembleMarketplaceOptionLabel(b))
    );
}
